import { useEffect, useState } from "react";
import { api } from "../api.js";
import { useUI } from "../lib/theme.js";

type CatalogEntry = {
  provider: string;
  displayName: string;
  capabilities: string[];
  status: string;
  brandColor: string;
  isConnected: boolean;
};

/**
 * Pantalla de onboarding: se muestra cuando el usuario está autenticado pero no tiene
 * ninguna fuente de datos conectada (conexiones = 0). Le invita a conectar al menos una.
 */
export function ConnectSources({ onSkip, onConnected }: { onSkip: () => void; onConnected: () => void }) {
  const { t } = useUI();
  const [catalog, setCatalog] = useState<CatalogEntry[]>([]);

  useEffect(() => {
    api.connections().then((data) => {
      // Solo mostrar las que tienen status live o mock (no soon)
      setCatalog(data.catalog.filter((e: CatalogEntry) => e.status !== "soon"));
      if (data.connected.length > 0) onConnected();
    }).catch(() => {});
  }, [onConnected]);

  function connectHref(provider: string) {
    return `/auth/${provider}`;
  }

  return (
    <main className="flex min-h-[100dvh] flex-col items-center justify-center gap-6 px-4 py-12">
      <div className="w-full max-w-md">
        <h1 className="mb-2 text-2xl font-extrabold tracking-tight text-fg">{t("connect_title")}</h1>
        <p className="mb-6 text-sm text-muted">{t("connect_desc")}</p>

        <div className="flex flex-col gap-3">
          {catalog.map((entry) => (
            <div
              key={entry.provider}
              className="flex items-center justify-between rounded-2xl border border-line bg-panel/60 px-4 py-3"
            >
              <div>
                <p className="font-semibold text-fg">{entry.displayName}</p>
                <p className="text-xs text-muted">
                  {entry.capabilities.map((c) => (c === "sport" ? t("sources_sport") : t("sources_health"))).join(" · ")}
                </p>
              </div>
              {entry.isConnected ? (
                <span className="rounded-full bg-accent/10 px-3 py-1 text-xs font-semibold text-accent">
                  {t("sources_connected")}
                </span>
              ) : (
                <a
                  href={connectHref(entry.provider)}
                  className="rounded-xl bg-accent px-4 py-1.5 text-xs font-semibold text-white transition hover:brightness-110"
                >
                  {t("connect_go")}
                </a>
              )}
            </div>
          ))}
        </div>

        <button
          onClick={onSkip}
          className="mt-6 w-full rounded-xl border border-line py-2.5 text-sm font-medium text-muted transition hover:text-fg"
        >
          {t("connect_skip")}
        </button>
      </div>
    </main>
  );
}
